import { ReactNode } from 'react';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { useRegisterBanner } from '@/providers/BannerProvider/BannerContext.hooks';
import {
  StyledBannerSection,
  StyledGradient,
  StyledWrapper,
} from '@/components/Banner/Banner.styled';

export type TBannerVariant = 'success' | 'error' | 'info' | 'warning' | 'neutral' | 'accent';

export interface IBannerProps {
  id: string;
  variant: TBannerVariant;
  children: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  center?: boolean;
}

export const Banner = ({ id, variant, icon, action, children, center = false }: IBannerProps) => {
  const { isDesktop } = useBreakpointsCtx();
  const stackIndex = useRegisterBanner(id);

  return (
    <StyledBannerSection
      isDesktop={isDesktop}
      stackIndex={stackIndex}
      variant={variant}
      data-testid={`banner-${id}`}
    >
      <StyledGradient variant={variant} shouldCenter={center}>
        <StyledWrapper>
          {icon}
          {children}
        </StyledWrapper>

        {action}
      </StyledGradient>
    </StyledBannerSection>
  );
};
